import { newRequest } from 'helpers/axios'

/**
 *
 * @param {number} jobOrderId
 * @param {string | null} html - null 'deletes' interview prep details
 * @returns
 */
export default async function postInterviewPrepDetails(jobOrderId, html) {
  try {
    return await newRequest(
      'POST',
      `/job-orders/interviewprepdetails/${jobOrderId}`,
      JSON.stringify(html),
      null
    )
  } catch (e) {
    console.error(e)
  }
}
